/* Build Your Stack: 10% only for items added through the Build Your Stack section.
   The 10% is the discount code BUILDSTACK10 (3+ items from the Bundle Discounts collection).
   1. When the Build Your Stack section reaches 3 items, the stack items are saved
      in this browser session. As soon as they are in the cart (same page, or the cart page the
      theme jumps to), the script records them in a hidden cart attribute (_stack_items) and
      applies the code.
   2. On every page load and cart change, it removes the code if fewer than 3 of the recorded
      stack items are still in the cart, so the 10% can't carry over to items added elsewhere.
   Loaded from layout/theme.liquid. */
(function () {
  if (window.SSStackCode) return;
  var CODE = 'BUILDSTACK10';
  var MIN = 3;
  var ATTR = '_stack_items';
  var KEY = 'ssStackPending';
  var RELOAD_KEY = 'ssStackReloaded';
  var SECTION_SUFFIX = '__un_bundle';
  var MAX_AGE = 120000;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var onCartPage = /\/cart\/?$/.test(location.pathname);
  var busy = false;

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function updateCart(body) {
    return fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function store(k, v) { try { v === null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (d) { return d.code; }); }
  function hasCode(cart) { return codesOf(cart).some(function (c) { return String(c).toUpperCase() === CODE; }); }
  function otherCodes(cart) { return codesOf(cart).filter(function (c) { return String(c).toUpperCase() !== CODE; }); }
  function stackMap(cart) {
    try { return JSON.parse((cart.attributes || {})[ATTR] || '{}') || {}; } catch (e) { return {}; }
  }
  function cartQty(cart) {
    var q = {};
    (cart.items || []).forEach(function (i) { q[i.variant_id] = (q[i.variant_id] || 0) + i.quantity; });
    return q;
  }
  /* Recorded stack items still in the cart, capped at what the builder added per variant. */
  function prune(cart, map) {
    var inCart = cartQty(cart), out = {}, count = 0;
    Object.keys(map).forEach(function (id) {
      var q = Math.min(Number(map[id]) || 0, inCart[id] || 0);
      if (q > 0) { out[id] = q; count += q; }
    });
    return { map: out, count: count };
  }
  function refreshCartUI() {
    if (onCartPage) {
      if (!read(RELOAD_KEY)) { store(RELOAD_KEY, '1'); location.reload(); }
      return;
    }
    try {
      var helper = window.Alpine && Alpine.store('xCartHelper');
      if (!helper || !helper.getSectionsToRender) return;
      var ids = helper.getSectionsToRender().map(function (s) { return s.id; });
      fetch(root + '?sections=' + ids.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sections) { helper.reRenderSections(sections); })
        .catch(function () {});
    } catch (e) {}
  }

  function pendingItems() {
    try {
      var p = JSON.parse(read(KEY) || 'null');
      if (!p || Date.now() - p.at > MAX_AGE) { store(KEY, null); return null; }
      return p.items;
    } catch (e) { store(KEY, null); return null; }
  }

  /* If the saved stack is now in the cart: record it and apply the code. Resolves true when done. */
  function applyPending() {
    var items = pendingItems();
    if (!items) return Promise.resolve(true);
    busy = true;
    return getCart().then(function (cart) {
      var inCart = cartQty(cart);
      var ready = Object.keys(items).every(function (id) { return (inCart[id] || 0) >= items[id]; });
      if (!ready) return false;
      store(KEY, null);
      var map = stackMap(cart);
      Object.keys(items).forEach(function (id) { map[id] = (Number(map[id]) || 0) + items[id]; });
      var p = prune(cart, map);
      var body = { attributes: {} };
      body.attributes[ATTR] = JSON.stringify(p.map);
      var wantCode = p.count >= MIN && !hasCode(cart);
      if (wantCode) body.discount = otherCodes(cart).concat([CODE]).join(',');
      return updateCart(body).then(function () { if (wantCode) refreshCartUI(); return true; });
    }).catch(function () { return false; }).then(function (done) { busy = false; return done; });
  }

  /* After a click, wait up to 10 seconds for the stack to land in the cart. */
  function waitAndApply(tries) {
    applyPending().then(function (done) {
      if (!done && tries > 0) setTimeout(function () { waitAndApply(tries - 1); }, 500);
    });
  }

  /* Remove the code when the recorded stack items no longer add up to 3. */
  function guard() {
    if (busy || pendingItems()) return;
    var mine = false;
    getCart().then(function (cart) {
      if (busy) return;
      if (!hasCode(cart) && !(cart.attributes || {})[ATTR]) return;
      var map = stackMap(cart);
      var p = prune(cart, map);
      var body = {}, changed = false;
      if (JSON.stringify(p.map) !== JSON.stringify(map)) {
        body.attributes = {}; body.attributes[ATTR] = Object.keys(p.map).length ? JSON.stringify(p.map) : '';
        changed = true;
      }
      var dropCode = hasCode(cart) && p.count < MIN;
      if (dropCode) { body.discount = otherCodes(cart).join(','); changed = true; }
      if (!changed) return;
      busy = true; mine = true;
      return updateCart(body).then(function () { if (dropCode) refreshCartUI(); });
    }).catch(function () {}).then(function () { if (mine) busy = false; });
  }

  /* Save the stack as soon as it reaches 3 items in the Build Your Stack section. The section may
     add to the cart by itself at that point (and jump to /cart), so nothing here waits for a click.
     The builder empties its list after adding; an empty list keeps the saved stack. */
  function onStackChange(list) {
    var items = {}, total = 0;
    (list || []).forEach(function (it) {
      var id = String(it.id), q = Number(it.quantity) || 1;
      items[id] = (items[id] || 0) + q; total += q;
    });
    if (total === 0) return;
    if (total < MIN) { store(KEY, null); return; }
    store(KEY, JSON.stringify({ items: items, at: Date.now() }));
    store(RELOAD_KEY, null);
    setTimeout(function () { waitAndApply(20); }, 300);
  }
  function hookBuilders() {
    document.querySelectorAll('[x-data*="xProductBundle"]').forEach(function (el) {
      var m = (el.getAttribute('x-data') || '').match(/xProductBundle\(\s*'([^']+)'/);
      if (!m || m[1].slice(-SECTION_SUFFIX.length) !== SECTION_SUFFIX || el.dataset.ssStackHooked) return;
      el.dataset.ssStackHooked = '1';
      document.addEventListener('eurus:product-bundle:productsList-changed-' + m[1], function (e) {
        onStackChange(e.detail && e.detail.productsBundle);
      });
    });
  }

  function start() {
    hookBuilders();
    if (pendingItems()) { waitAndApply(10); } else { guard(); }
    if (onCartPage) setTimeout(function () { store(RELOAD_KEY, null); }, 3000);
  }
  document.addEventListener('eurus:cart:items-changed', function () { setTimeout(guard, 400); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.SSStackCode = { guard: guard, apply: applyPending, code: CODE };
})();
